export function roundTo(number: number, digits: number): number {
  return Math.round(number * 10 ** digits) / 10 ** digits;
}

export function floorTo(number: number, digits: number): number {
  return Math.floor(number * 10 ** digits) / 10 ** digits;
}
